import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'
import type { paths } from './schema'
import { env } from '@/env'
import { getCookie } from 'cookies-next/client'

// Determine if we're on the server side
const isServer = typeof window === 'undefined'

// Use server URL for server-side calls if available, otherwise fallback to public URL
export const API_BASE_URL = isServer && env.NEXT_SERVER_BACKEND_URL 
  ? env.NEXT_SERVER_BACKEND_URL 
  : env.NEXT_PUBLIC_BACKEND_URL

export const fetchClient = createFetchClient<paths>({
  baseUrl: API_BASE_URL,
})

export const $api = createClient(fetchClient)

export const getAuthHeader = () => {
  const accessToken = getCookie('access_token')
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
}
